import { render, staticRenderFns } from "./questions-randoms.vue?vue&type=template&id=602dcef0&scoped=true&"
import script from "./questions-randoms.vue?vue&type=script&lang=js&"
export * from "./questions-randoms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602dcef0",
  null
  
)

export default component.exports